<script>
export default {
  name: "ProgramSessionOrdersSummary",
};
</script>

<script setup>
defineProps({
  summary: {
    type: Array,
    default: () => [],
  },
});
</script>

<template>
  <div class="border border-gray-300 rounded-sm p-8 bg-blue-300">
    <ul class="flex w-full justify-between">
      <li v-for="item in summary">
        <div
          v-if="item.count && item.status"
          class="flex flex-col items-center"
        >
          <span class="font-bold text-lg">{{ item?.count }}</span>
          <span>{{ item?.status }} requests</span>
        </div>
      </li>
    </ul>
  </div>
</template>
